import React, { useCallback, useMemo } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import styles from './EventsBar.module.scss'
import { ReactComponent as ArrowRight } from '../../assets/media/icons/icon-arrow-right.svg'
import { useEvents } from '../../hooks'
import { EVENT_TYPE_CODES, WEEKLY_AVAILABILITY_DAYS_LIMIT } from '../../constants'
import FormatUtilities from '../../utilities/FormatUtilities'

const EventsBar = ({ item, localizations, showButton }) => {
    const { handleViewAllEventsClick } = useEvents()
    const currentLocationEvents = useMemo(() => {
        return item?.events || []
    }, [item])

    const availabilityText = useMemo(() => {
        if (currentLocationEvents?.length === 1) {
            const eventDaysDuration = moment(currentLocationEvents[0].endDate).diff(moment(currentLocationEvents[0].startDate), 'days')

            if (eventDaysDuration > WEEKLY_AVAILABILITY_DAYS_LIMIT) {
                return <span className={styles.availabilityText}>{localizations.weeklyAvailability}</span>
            }
        }

        return (
            <>
                <span className={styles.availabilityText}>{currentLocationEvents.length}</span>
                {` Event${currentLocationEvents.length === 1 ? '' : 's'}`}
            </>
        )
    }, [currentLocationEvents])

    const buttonProps = useMemo(() => {
        if (currentLocationEvents?.length > 1) {
            return {
                text: localizations.viewAllEvents,
                isExternal: false,
                href: undefined,
            }
        }

        if (currentLocationEvents?.length === 1) {
            if (currentLocationEvents[0].eventTypeCode === EVENT_TYPE_CODES.DEMO) {
                return {
                    text: localizations.demoDayDetails,
                    href: `${process.env.REACT_APP_EAS_WEBAPP_URL}${process.env.REACT_APP_EAS_WEBAPP_LANDING_PAGE_PATH.replace('{id}', currentLocationEvents[0].id)}`,
                    isExternal: false,
                }
            } else if (currentLocationEvents[0].eventTypeCode === EVENT_TYPE_CODES.EXTERNAL) {
                return {
                    text: localizations.bookAFitting,
                    href: FormatUtilities.formatUrl(currentLocationEvents[0]?.externalUrl),
                    isExternal: true,
                }
            } else {
                return {
                    text: localizations.bookAFitting,
                    href: `${process.env.REACT_APP_EAS_WEBAPP_URL}${process.env.REACT_APP_EAS_WEBAPP_CREATE_APPOINTMENT_PATH.replace('{id}', currentLocationEvents[0].id)}`,
                    isExternal: false,
                }
            }
        }

        return {
            text: '',
            href: undefined,
            isExternal: false,
        }
    }, [currentLocationEvents])

    const handleMultipleEventsClick = useCallback(e => {
        e.stopPropagation()
        handleViewAllEventsClick(item)
    }, [])

    const getArrow = () => {
        if (showButton) {
            return <ArrowRight />
        }

        return (
            <span className={styles.eventLink_arrow}>
                <ArrowRight />
            </span>
        )
    }

    return (
        <>
            {currentLocationEvents ? (
                currentLocationEvents.length > 0 ? (
                    <div className={styles.eventsSection}>
                        <div>{availabilityText}</div>
                        {currentLocationEvents.length > 1 ? (
                            <button type='button' className={showButton ? styles.eventButton : styles.eventLink} onClick={handleMultipleEventsClick}>
                                {buttonProps.text} {getArrow()}
                            </button>
                        ) : (
                            <a
                                className={showButton ? styles.eventButton : styles.eventLink}
                                href={buttonProps.href}
                                onClick={e => {
                                    e.stopPropagation()
                                    if (!buttonProps.isExternal) {
                                        return
                                    }

                                    if (confirm(localizations.messages.externalLink)) {
                                        return true
                                    } else {
                                        return e.preventDefault()
                                    }
                                }}
                                target='_blank'
                                rel='noreferrer nofollow'
                                aria-label={`${buttonProps.text} at ${item?.name || 'location'}`}
                            >
                                {buttonProps.text}
                                {getArrow()}
                            </a>
                        )}
                    </div>
                ) : null
            ) : null}
        </>
    )
}

EventsBar.propTypes = {
    item: PropTypes.object,
    localizations: PropTypes.object,
    showButton: PropTypes.bool,
}

export default EventsBar
